import { InjectionToken } from '@angular/core';
import { PushChannelFactory } from './push-channel-factory';

export const PUSH_CHANNEL_FACTORY = new InjectionToken<PushChannelFactory>(
  'PushChannelFactory'
);
